module.exports = __webpack_public_path__ + "static/media/Erfolgsstory_Europa.7367705a.webp";